import { render, staticRenderFns } from "./u-dialog-img.vue?vue&type=template&id=3f2d82bc&scoped=true&"
import script from "./u-dialog-img.vue?vue&type=script&lang=js&"
export * from "./u-dialog-img.vue?vue&type=script&lang=js&"
import style0 from "./u-dialog-img.vue?vue&type=style&index=0&id=3f2d82bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d82bc",
  null
  
)

export default component.exports